// extracted by mini-css-extract-plugin
export default {"controls":"ModalControls_controls__yYZxh","counter":"ModalControls_counter__ePjCz","rightButtons":"ModalControls_rightButtons__1XsZq","button":"ModalControls_button__Qaq-4"};